var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"content"},[_c('ListCart',{attrs:{"dataList":[..._vm.dataList, ..._vm.invalidList],"dataListLoading":_vm.loading,"activited":_vm.activited},on:{"refresh":_vm.doSearch}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }